import { useEffect, useState } from 'react'
import { supabase } from '../../../../lib/supabase'

export default function StatsCards() {
  const [stats, setStats] = useState({ total: 0, paid: 0, unpaid: 0, chapters: 0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStats = async () => {
      const clubId = 'a0000000-0000-0000-0000-000000000001'
      const today = new Date().toISOString().split('T')[0]

      const [
        { count: total },
        { count: chapters },
        { data: supporters },
        { data: activeSubscriptions },
      ] = await Promise.all([
        supabase.from('supporters').select('*', { count: 'exact', head: true })
          .eq('club_id', clubId).eq('role', 'supporter'),
        supabase.from('chapters').select('*', { count: 'exact', head: true })
          .eq('club_id', clubId),
        supabase.from('supporters').select('id')
          .eq('club_id', clubId).eq('role', 'supporter'),
        supabase.from('subscriptions').select('supporter_id')
          .eq('club_id', clubId).gte('valid_until', today).eq('status', 'active'),
      ])

      const paidIds = new Set((activeSubscriptions || []).map(s => s.supporter_id))
      const totalSupporters = supporters?.length || 0
      const paid = (supporters || []).filter(s => paidIds.has(s.id)).length
      const unpaid = totalSupporters - paid

      setStats({
        total: total || 0,
        paid,
        unpaid,
        chapters: chapters || 0,
      })
      setLoading(false)
    }
    fetchStats()
  }, [])

  const cards = [
    { label: 'Total Members', value: stats.total, color: 'text-gray-900 dark:text-white' },
    { label: 'Paid Members', value: stats.paid, color: 'text-green-600 dark:text-green-400' },
    { label: 'Unpaid Members', value: stats.unpaid, color: 'text-yellow-600 dark:text-yellow-400' },
    { label: 'Active Chapters', value: stats.chapters, color: 'text-blue-600 dark:text-blue-400' },
  ]

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div key={card.label} className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 px-6 py-5">
          <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-2">{card.label}</div>
          <div className={`text-3xl font-black ${loading ? 'opacity-30' : ''} ${card.color}`}>
            {loading ? '—' : card.value}
          </div>
        </div>
      ))}
    </div>
  )
}